// ENUMS #############################################################
export enum LinkItemTypeEnum {
	EMAIL = 'email',
	EXTERNAL = 'external',
	INTERNAL = 'internal'
}

// INTERFACES ########################################################


// TYPES #############################################################

